import http from './http'
// import config from '@/utils/config'

const exchangeRate = `/ExchangeRate`
function getExchangeRatePages(params) {
  return http.post(`${exchangeRate}/getExchangeRatePages`, params)
}
function addExchangeRate(params) {
  return http.post(`${exchangeRate}/addExchangeRate`, params)
}
function updateExchangeRate(params) {
  return http.post(`${exchangeRate}/updateExchangeRate`, params)
}
function getCurrency(params) {
  return http.get(`${exchangeRate}/getCurrency`, params)
}
function getExchangeRate(params) {
  return http.post(`${exchangeRate}/getExchangeRate`, params)
}

const bankAccount = `/BankAccount`

function switchBankAccount(params) {
    return http.get(`${bankAccount}/switchBankAccount`, params)
}
function getBankAccountCompany(params) {
    return http.get(`${bankAccount}/GetBankAccountCompany`, params)
}
function deleteBankAccountCompany(params) {
    return http.get(`${bankAccount}/deleteBankAccountCompany`, params)
}
function getBankAccountPageList(params) {
    return http.post(`${bankAccount}/GetBankAccountPageList`, params)
}
function insertBankAccount(params) {
    return http.post(`${bankAccount}/insertBankAccount`, params)
}
function updateBankAccount(params) {
    return http.post(`${bankAccount}/updateBankAccount`, params)
}
function insertBankAccountCompany(params) {
    return http.post(`${bankAccount}/insertBankAccountCompany`, params)
}
function getBankAccountList(params) {
    return http.get(`${bankAccount}/GetBankAccountList`, params)
}
function companyBankAccount(params) {
    return http.get(`${bankAccount}/companyBankAccount`, params)
}
function batchBankAccountCompany(params) {
    return http.post(`${bankAccount}/batchBankAccountCompany`, params)
}

const fee = `/fee`
function switchFeeName(params) {
  return http.get(`${fee}/switchFeeName`, params)
}
function getFeeTypeList(params) {
  return http.get(`${fee}/GetFeeTypeList`, params)
}
function GetFeeNameList(params) {
  return http.get(`${fee}/GetFeeNameList`, params)
}
function getFeeNamePageList(params) {
  return http.post(`${fee}/GetFeeNamePageList`, params)
}
function insertFeeName(params) {
  return http.post(`${fee}/insertFeeName`, params)
}
function insertFeeType(params) {
  return http.post(`${fee}/insertFeeType`, params)
}
function deleteFeeName(params) {
  return http.delete(`${fee}/deleteFeeName`, params)
}
function updateFeeName(params) {
  return http.post(`${fee}/updateFeeName`, params)
}
function GetFeeNameListById(params) {
  return http.get(`${fee}/GetFeeNameListById`, params)
}

const Quote = `/Quote`
function originCity(params) {
  return http.get(`${Quote}/originCity`, params)
}
function availableAccounts(params) {
  return http.get(`${Quote}/availableAccounts`, params)
}
function quotes(params) {
  return http.post(`${Quote}/quotes`, params)
}
function getTariffCalculate(params) {
  return http.post(`${Quote}/getTariffCalculate`, params)
}
function importTariffCalculateExcel(params) {
  return http.upload(`/api/${Quote}/importTariffCalculateExcel`, params)
}
function downloadTariffCalculateExcel(params) {
  return http.download(`/${Quote}/downloadTariffCalculateExcel`, params)
}
function getTruckRate(params) {
  return http.post(`${Quote}/getTruckRate`, params)
}
function addressValidation(params) {
  return http.post(`${Quote}/addressValidation`, params)
}

const Order = `/Order`
function getTrackPages(params) {
  return http.post(`${Order}/getTrackPages`, params)
}
function trackDetail(params) {
  return http.get(`${Order}/trackDetail`, params)
}
function getOrderPageList(params) {
  return http.post(`${Order}/getOrderPageList`, params)
}
function cancel(params) {
  return http.delete(`${Order}/cancel`, params)
}
function deleteOrder(params) {
  return http.delete(`${Order}/delete`, params)
}
function trackOverview(params) {
  return http.post(`${Order}/trackOverview`, params)
}
function getEstimateRate(params) {
  return http.get(`${Order}/getEstimateRate`, params)
}
function batchUploadData(params) {
  return http.get(`${Order}/batchUploadData`, params)
}
function shipment(params) {
  return http.post(`${Order}/shipment`, params)
}
function getOrderDetail(params) {
  return http.get(`${Order}/getOrderDetail`, params)
}
function getOrderProductPageList(params) {
  return http.post(`${Order}/getOrderProductPageList`, params)
}
function getOrderDimensionPageList(params) {
  return http.post(`${Order}/getOrderDimensionPageList`, params)
}
function existsTrackingNumber(params) {
  return http.get(`${Order}/existsTrackingNumber`, params)
}
function getReprintLabelPageList(params) {
  return http.post(`${Order}/getReprintLabelPageList`, params)
}
function deleteReprintLabel(params) {
  return http.post(`${Order}/deleteReprintLabel`, params)
}
function reprintLabel(params, companyId) {
  return http.upload(`/api/${Order}/reprintLabel?companyId=${companyId}`, params)
}
function checkReprintNumbers(params, companyId) {
  return http.post(`${Order}/checkReprintNumbers?companyId=${companyId}`, params)
}
function uploadReprintLabel(params, companyId) {
  return http.upload(`/api/${Order}/uploadReprintLabel?companyId=${companyId}`, params)
}
function getUnboundMblOrders(params) {
  return http.post(`${Order}/getUnboundMblOrders`, params)
}
function refreshOrderTrack(params) {
  return http.get(`${Order}/refreshOrderTrack`, params)
}
function automaticSaveNonSystemOrder(params) {
  return http.post(`${Order}/automaticSaveNonSystemOrder`, params)
}
function updateField(params) {
  return http.post(`${Order}/updateField`, params)
}
function getOrderListBySendWay(params) {
  return http.get(`${Order}/getOrderListBySendWay`, params)
}

const Finance = `/Surcharge`
function getSurchargePageList(params) {
  return http.post(`${Finance}/getSurchargePageList`, params)
}
function markSurchargeException(params) {
  return http.post(`${Finance}/markSurchargeException`, params)
}
function markSurchargeNormal(params) {
  return http.post(`${Finance}/markSurchargeNormal`, params)
}
function addSurcharge(params) {
  return http.post(`${Finance}/addSurcharge`, params)
}
function readSurchargeFile(params) {
  return http.upload(`/api/${Finance}/readSurchargeFile`, params)
}
function getRateAdjustment(params) {
  return http.get(`${Finance}/getRateAdjustment`, params)
}
function getRateAdjustmentDetail(params) {
  return http.post(`${Finance}/getRateAdjustmentDetail`, params)
}
function exportRateAdjustmentDetail(params) {
  return http.download(`${Finance}/exportRateAdjustmentDetail`, params, 'get')
}
function arApTemplateList(params) {
  return http.get(`${Finance}/arApTemplateList`, params)
}
function saveArApTemplate(params) {
  return http.post(`${Finance}/saveArApTemplate`, params)
}
function deleteArApTemplate(params) {
  return http.delete(`${Finance}/deleteArApTemplate`, params)
}

const Payable = `/Payable`
function getPayablePages(params) {
  return http.post(`${Payable}/getPayablePages`, params)
}
function getPayablePages1(params) {
  return http.post(`${Payable}/getPayablePages1`, params)
}
function updatePayableDetail(params) {
  return http.post(`${Payable}/updatePayableDetail`, params)
}
function createSharePayableInvoice(params) {
  return http.upload(`/api${Payable}/createSharePayableInvoice`, params)
}
function createPayable(params) {
  return http.upload(`/api${Payable}/createPayable`, params)
}
function reviewedPayableInvoice(params) {
  return http.get(`${Payable}/reviewedPayableInvoice`, params)
}
function deletePayableInvoice(params) {
  return http.post(`${Payable}/deletePayableInvoice`, params)
}
function deletePayable(params) {
  return http.post(`${Payable}/deletePayable`, params)
}

function repeatReviewedPayableInvoice(params) {
  return http.get(`${Payable}/repeatReviewedPayableInvoice`, params)
}
function getPayableDetail(params) {
  return http.get(`${Payable}/getPayableDetail`, params)
}
function getSupplierFeeIdentifyTemplate(params) {
  return http.get(`${Payable}/getSupplierFeeIdentifyTemplate`, params)
}
function getSupplierFeeIdentifyTemplateDetail(params) {
  return http.get(`${Payable}/getSupplierFeeIdentifyTemplateDetail`, params)
}
function modifySupplierFeeIdentify(params) {
  return http.post(`${Payable}/modifySupplierFeeIdentify`, params)
}
function delSupplierFeeIdentify(params) {
  return http.get(`${Payable}/delSupplierFeeIdentify`, params)
}
function SupplierPayableFeeIdentify(params) {
  return http.get(`${Payable}/SupplierPayableFeeIdentify`, params)
}
function reviewedPayableInvoiceBatch(params) {
  return http.post(`${Payable}/reviewedPayableInvoiceBatch`, params)
}
function batchRepeatReviewedPayable(params) {
  return http.post(`${Payable}/batchRepeatReviewedPayable`, params)
}
function completePayable(params) {
  return http.post(`${Payable}/completePayable`, params)
}

function reviewedPayable(params) {
  return http.post(`${Payable}/reviewedPayable`, params)
}

function getPayableDetailPages(params) {
  return http.post(`${Payable}/getPayableDetailPages`, params)
}
function batchRepeatReviewedPayableInvoice(params) {
  return http.post(`${Payable}/batchRepeatReviewedPayableInvoice`, params)
}
function importPayable(params) {
  return http.post(`${Payable}/importPayable`, params)
}
function supplierInvoiceData(params) {
  return http.post(`${Payable}/supplierInvoiceData`, params)
}
function generateInvoiceByPayable(params) {
  return http.post(`${Payable}/generateInvoice`, params)
}
// function getPayableDetailPages(params) {
//   return http.post(`${Payable}/getPayableDetailPages`, params)
// }

const Receivable = `/Receivable`
function customerInvoiceData(params) {
  return http.post(`${Receivable}/customerInvoiceData`, params)
}
function generateInvoiceByReceivable(params) {
  return http.post(`${Receivable}/generateInvoice`, params)
}
function getReceivablePages(params) {
  return http.post(`${Receivable}/getReceivablePages`, params)
}
function getReceivablePages1(params) {
  return http.post(`${Receivable}/getReceivablePages1`, params)
}
function completeReceivable(params) {
  return http.get(`${Receivable}/completeReceivable`, params)
}
function postCompleteReceivable(params) {
  return http.post(`${Receivable}/completeReceivable`, params)
}

function getReceivableDetail(params) {
  return http.get(`${Receivable}/getReceivableDetail`, params)
}
function updateReceivableDetail(params) {
  return http.post(`${Receivable}/updateReceivableDetail`, params)
}
function reviewedReceivableDetails(params) {
  return http.post(`${Receivable}/reviewedReceivableDetails`, params)
}
function deleteReceivableInvoice(params) {
  return http.get(`${Receivable}/deleteReceivableInvoice`, params)
}
function cancelReviewedReceivable(params) {
  return http.get(`${Receivable}/cancelReviewedReceivable`, params)
}
function reviewedReceivable(params) {
  return http.get(`${Receivable}/reviewedReceivable`, params)
}
function postReviewedReceivable(params) {
  return http.post(`${Receivable}/reviewedReceivable`, params)
}
function postDeleteReceivableInvoice(params) {
  return http.post(`${Receivable}/deleteReceivableInvoice`, params)
}
function postCancelReviewedReceivable(params) {
  return http.post(`${Receivable}/cancelReviewedReceivable`, params)
}

function importReceivable(params) {
  return http.post(`${Receivable}/importReceivable`, params)
}

const ReconInfomation = `/ReconInfomation`
function getReconInvocePages(params) {
  return http.post(`${ReconInfomation}/getReconInvocePages`, params)
}
function addReconFeeNameMapping(params) {
  return http.post(`${ReconInfomation}/addReconFeeNameMapping`, params)
}
function updateReconFeeNameMapping(params) {
  return http.post(`${ReconInfomation}/updateReconFeeNameMapping`, params)
}
function getReconFeeNameMappingList(params) {
  return http.get(`${ReconInfomation}/getReconFeeNameMappingList`, params)
}
function deleteReconFeeNameMapping(params) {
  return http.get(`${ReconInfomation}/deleteReconFeeNameMapping`, params)
}
function deleteReconInvoce(params) {
  return http.get(`${ReconInfomation}/deleteReconInvoce`, params)
}
function existsReconInvoiceNo(params) {
  return http.get(`${ReconInfomation}/existsReconInvoiceNo`, params)
}
function reconciliation(params) {
  return http.get(`${ReconInfomation}/reconciliation`, params)
}
function ReconInfoImport(params) {
  return http.post(`${ReconInfomation}/ReconInfoImport`, params)
}
function getReconDetailPages(params) {
  return http.post(`${ReconInfomation}/getReconDetailPages`, params)
}
function ReconDetailReview(params) {
  return http.post(`${ReconInfomation}/ReconDetailReview`, params)
}
function getReconciliationResult(params) {
  return http.get(`${ReconInfomation}/getReconciliationResult`, params)
}
function generatePayment(params) {
  return http.post(`${ReconInfomation}/generatePayment`, params)
}

const CustomerInvoice = `/CustomerInvoice`
function getPages(params) {
  return http.post(`${CustomerInvoice}/getPages`, params)
}
function generateInvoices(params) {
  return http.post(`${CustomerInvoice}/generateInvoices`, params)
}

function companyAccountVerifyPages(params) {
  return http.post(`${CustomerInvoice}/companyAccountVerifyPages`, params)
}
function reviewInvoice(params) {
  return http.get(`${CustomerInvoice}/reviewInvoice`, params)
}
function getCustomerInvoiceStartDate(params) {
  return http.get(`${CustomerInvoice}/getCustomerInvoiceStartDate`, params)
}
function antiReviewInvoice(params) {
  return http.get(`${CustomerInvoice}/antiReviewInvoice`, params)
}
function deleteCustomerInvoice(params) {
  return http.get(`${CustomerInvoice}/deleteCustomerInvoice`, params)
}
function usageVerifyDetail(params) {
  return http.get(`${CustomerInvoice}/usageVerifyDetail`, params)
}

function verifyPages(params) {
  return http.post(`${CustomerInvoice}/verifyPages`, params)
}
function verify(params) {
  return http.post(`${CustomerInvoice}/verify`, params)
}
function cancelVerify(params) {
  return http.get(`${CustomerInvoice}/cancelVerify`, params)
}
function verifyDetailPages(params) {
  return http.post(`${CustomerInvoice}/verifyDetailPages`, params)
}
function verifySurcharges(params) {
  return http.get(`${CustomerInvoice}/verifySurcharges`, params)
}

function getInvoicePaymentVerifyDetails(params) {
  return http.get(`${CustomerInvoice}/getInvoicePaymentVerifyDetails`, params)
}

const SupplierInvoice = `/SupplierInvoice`
function getSupplierPages(params) {
  return http.post(`${SupplierInvoice}/getPages`, params)
}
function generateSupplierInvoices(params) {
  return http.post(`${SupplierInvoice}/generateInvoices`, params)
}
function getSupplierInvoiceStartDate(params) {
  return http.get(`${SupplierInvoice}/getInvoiceStartDate`, params)
}
function reviewSupplierInvoice(params) {
  return http.get(`${SupplierInvoice}/reviewInvoice`, params)
}
function antiSupplierReviewInvoice(params) {
  return http.get(`${SupplierInvoice}/antiReviewInvoice`, params)
}
function deleteSupplierInvoice(params) {
  return http.get(`${SupplierInvoice}/deleteInvoice`, params)
}
function supplierAccountVerifyPages(params) {
  return http.post(`${SupplierInvoice}/supplierAccountVerifyPages`, params)
}
function verifyDetailPagesBySupplier(params) {
  return http.post(`${SupplierInvoice}/verifyDetailPages`, params)
}
function cancelVerifyBySupplier(params) {
  return http.get(`${SupplierInvoice}/cancelVerify`, params)
}
function verifyPagesBySupplier(params) {
  return http.post(`${SupplierInvoice}/verifyPages`, params)
}
function verifyBySupplier(params) {
  return http.post(`${SupplierInvoice}/verify`, params)
}
function usageVerifyDetailBySupplier(params) {
  return http.get(`${SupplierInvoice}/usageVerifyDetail`, params)
}
function getInvoicePaymentVerifyDetailsBySupplier(params) {
  return http.get(`${SupplierInvoice}/getInvoicePaymentVerifyDetails`, params)
}

const Defray = `/Defray`
function getDefrayPageList(params) {
  return http.post(`${Defray}/getDefrayPageList`, params)
}
function getWaitDefrayInvoice(params) {
  return http.post(`${Defray}/getWaitDefrayInvoice`, params)
}
function getDefrayInvoice(params) {
  return http.get(`${Defray}/getDefrayInvoice`, params)
}
function deleteDefray(params) {
  return http.get(`${Defray}/deleteDefray`, params)
}
function getDefrayReviewRecord(params) {
  return http.get(`${Defray}/getDefrayReviewRecord`, params)
}
function addDefray(params) {
  return http.post(`${Defray}/addDefray`, params)
}
function checkAddDefray(params) {
  return http.post(`${Defray}/checkAddDefray`, params)
}
function mergeDefrayPDF(params) {
  return http.post(`${Defray}/mergeDefrayPDF`, params)
}
function reviewDefray(params) {
  return http.upload(`/api/${Defray}/reviewDefray`, params)
}
function getDefrayPaymentPage(params) {
  return http.post(`${Defray}/getDefrayPaymentPage`, params)
}
function getNotReviewDefrayInvoice(params) {
  return http.post(`${Defray}/getNotReviewDefrayInvoice`, params)
}
function paymentDefray(params) {
  return http.upload(`/api/${Defray}/paymentDefray`, params)
}
function getDefrayPaymentDetail(params) {
  return http.get(`${Defray}/getDefrayPaymentDetail`, params)
}
function getDefrayAttachmentList(params) {
  return http.get(`${Defray}/getDefrayAttachmentList`, params)
}
function delDefrayAttachment(params) {
  return http.get(`${Defray}/delDefrayAttachment`, params)
}

function batchUploadDefrayFile(params) {
  return http.upload(`/api/${Defray}/batchUploadDefrayFile`, params)
}
function updateDefrayInvoiceRemark(params) {
  return http.get(`${Defray}/updateDefrayInvoiceRemark`, params)
}

const Analysis = `/Analysis`
function grossProfitClePicPages(params) {
  return http.post(`${Analysis}/grossProfitClePicPages`, params)
}
function grossProfitDeliveryPage(params) {
  return http.post(`${Analysis}/grossProfitDeliveryPage`, params)
}
function grossProfitClePicDetail(params) {
  return http.post(`${Analysis}/grossProfitClePicDetail`, params)
}
function grossProfitCloseClePic(params) {
  return http.post(`${Analysis}/grossProfitCloseClePic`, params)
}
function grossProfitDeliveryDetail(params) {
  return http.post(`${Analysis}/grossProfitDeliveryDetail`, params)
}
function grossProfitExportClePicOrigin(params) {
  return http.download(`${Analysis}/grossProfitExportClePicOrigin`, params, 'post')
}
function grossProfitExportClePicProfit(params) {
  return http.download(`${Analysis}/grossProfitExportClePicProfit`, params, 'post')
}
function grossProfitExportClePicPayble(params) {
  return http.download(`${Analysis}/grossProfitExportClePicPayble`, params, 'post')
}
function grossProfitCloseDelivery(params) {
  return http.post(`${Analysis}/grossProfitCloseDelivery`, params)
}
function grossProfitOtherServicePage(params) {
  return http.post(`${Analysis}/grossProfitOtherServicePages`, params)
}
function grossProfitOtherServiceDetail(params) {
  return http.get(`${Analysis}/grossProfitOtherServiceDetail`, params)
}

function CloseOtherServiceAmount(params) {
  return http.post(`${Analysis}/CloseOtherServiceAmount`, params)
}

const TruckQuote = `/TruckQuote`
function getTruckQuotePages(params) {
  return http.post(`${TruckQuote}/getTruckQuotePages`, params)
}
function sendEmailTruckQuote(params) {
  return http.post(`${TruckQuote}/sendEmailTruckQuote`, params)
}
function deleteTruckQuotePrice(params) {
  return http.delete(`${TruckQuote}/deleteTruckQuotePrice`, params)
}
function deleteTruckQuote(params) {
  return http.post(`${TruckQuote}/deleteTruckQuote`, params)
}

function addOrUpdateTruckQuote(params) {
  return http.post(`${TruckQuote}/addOrUpdateTruckQuote`, params)
}
function getTruckQuoteProducts(params) {
  return http.get(`${TruckQuote}/getTruckQuoteProducts`, params)
}
function addTruckQuotePrice(params) {
  return http.post(`${TruckQuote}/addTruckQuotePrice`, params)
}
function getTruckQuotePriceList(params) {
  return http.get(`${TruckQuote}/getTruckQuotePriceList`, params)
}

const OpenClaim = `/OpenClaim`
function getOpenClaimPageList(params) {
  return http.post(`${OpenClaim}/getOpenClaimPageList`, params)
}
function deleteData(params) {
  return http.delete(`${OpenClaim}/deleteData`, params)
}
function approved(params) {
  return http.put(`${OpenClaim}/approved`, params)
}
function reject(params) {
  return http.put(`${OpenClaim}/reject`, params)
}
function checkFail(params) {
  return http.upload(`/api/${OpenClaim}/checkFail`, params)
}
function claimFail(params) {
  return http.upload(`/api/${OpenClaim}/claimFail`, params)
}
function claimSuccess(params) {
  return http.upload(`/api/${OpenClaim}/claimSuccess`, params)
}
function checkSuccess(params) {
  return http.put(`${OpenClaim}/checkSuccess`, params)
}
function uploadSingleData(params) {
  return http.upload(`/api/${OpenClaim}/uploadSingleData`, params)
}
function claimConfirm(params) {
  return http.put(`${OpenClaim}/claimConfirm`, params)
}
function GetOpenClaimFileListOutput(params) {
  return http.get(`${OpenClaim}/GetOpenClaimFileListOutput`, params)
}
function checkAddOpenClaim(params) {
  return http.post(`${OpenClaim}/checkAddOpenClaim`, params)
}
function completion(params) {
  return http.post(`${OpenClaim}/completion`, params)
}
function getClaimReason(params) {
  return http.get(`${OpenClaim}/getClaimReason`, params)
}
function setFollowUp(params) {
  return http.post(`${OpenClaim}/setFollowUp`, params)
}

export {
  getExchangeRatePages,
  addExchangeRate,
  updateExchangeRate,
  switchBankAccount,
  getBankAccountCompany,
  deleteBankAccountCompany,
  getBankAccountPageList,
  insertBankAccount,
  insertBankAccountCompany,
  switchFeeName,
  getFeeTypeList,
  getFeeNamePageList,
  insertFeeName,
  insertFeeType,
  originCity,
  availableAccounts,
  quotes,
  getTrackPages,
  trackDetail,
  getTariffCalculate,
  importTariffCalculateExcel,
  downloadTariffCalculateExcel,
  getTruckRate,
  addressValidation,
  getOrderPageList,
  cancel,
  deleteOrder,
  trackOverview,
  getEstimateRate,
  batchUploadData,
  shipment,
  getOrderDetail,
  getOrderProductPageList,
  getOrderDimensionPageList,
  getSurchargePageList,
  getReconInvocePages,
  addReconFeeNameMapping,
  getReconFeeNameMappingList,
  deleteReconFeeNameMapping,
  ReconInfoImport,
  deleteReconInvoce,
  getReconDetailPages,
  updateReconFeeNameMapping,
  ReconDetailReview,
  existsReconInvoiceNo,
  reconciliation,
  getPayablePages,
  getPayablePages1,
  reviewedPayableInvoice,
  deletePayableInvoice,
  deletePayable,
  repeatReviewedPayableInvoice,
  createSharePayableInvoice,
  createPayable,
  getPayableDetail,
  updatePayableDetail,
  GetFeeNameList,
  getReceivablePages,
  getReceivablePages1,
  getReceivableDetail,
  updateReceivableDetail,
  reviewedReceivableDetails,
  completeReceivable,
  markSurchargeNormal,
  markSurchargeException,
  generateInvoices,
  reviewInvoice,
  existsTrackingNumber,
  addSurcharge,
  readSurchargeFile,
  getRateAdjustment,
  getRateAdjustmentDetail,
  getDefrayPageList,
  getWaitDefrayInvoice,
  getDefrayInvoice,
  addDefray,
  checkAddDefray,
  deleteDefray,
  getDefrayReviewRecord,
  reviewDefray,
  mergeDefrayPDF,
  getPages,
  getReprintLabelPageList,
  getCustomerInvoiceStartDate,
  deleteReprintLabel,
  deleteFeeName,
  reprintLabel,
  checkReprintNumbers,
  uploadReprintLabel,
  getUnboundMblOrders,
  getReconciliationResult,
  grossProfitClePicPages,
  grossProfitDeliveryPage,
  grossProfitClePicDetail,
  grossProfitCloseClePic,
  grossProfitDeliveryDetail,
  grossProfitExportClePicOrigin,
  grossProfitExportClePicProfit,
  grossProfitExportClePicPayble,
  grossProfitCloseDelivery,
  getDefrayPaymentPage,
  getNotReviewDefrayInvoice,
  paymentDefray,
  updateFeeName,
  getDefrayPaymentDetail,
  getTruckQuotePages,
  addOrUpdateTruckQuote,
  getTruckQuoteProducts,
  addTruckQuotePrice,
  getTruckQuotePriceList,
  refreshOrderTrack,
  getSupplierFeeIdentifyTemplate,
  getSupplierFeeIdentifyTemplateDetail,
  modifySupplierFeeIdentify,
  delSupplierFeeIdentify,
  SupplierPayableFeeIdentify,
  exportRateAdjustmentDetail,
  getBankAccountList,
  getCurrency,
  getExchangeRate,
  automaticSaveNonSystemOrder,
  batchUploadDefrayFile,
  getDefrayAttachmentList,
  delDefrayAttachment,
  reviewedPayableInvoiceBatch,
  batchRepeatReviewedPayable,
  completePayable,
  reviewedPayable,
  getPayableDetailPages,
  updateField,
  getOpenClaimPageList,
  deleteData,
  approved,
  reject,
  checkFail,
  claimFail,
  claimSuccess,
  checkSuccess,
  uploadSingleData,
  claimConfirm,
  GetOpenClaimFileListOutput,
  checkAddOpenClaim,
  completion,
  updateDefrayInvoiceRemark,
  batchRepeatReviewedPayableInvoice,
  generatePayment,
  getOrderListBySendWay,
  GetFeeNameListById,
  grossProfitOtherServicePage,
  CloseOtherServiceAmount,
  getClaimReason,
  setFollowUp,
  sendEmailTruckQuote,
  deleteTruckQuotePrice,
  deleteTruckQuote,
  updateBankAccount,
  deleteReceivableInvoice,
  arApTemplateList,
  saveArApTemplate,
  deleteArApTemplate,
  cancelReviewedReceivable,
  antiReviewInvoice,
  deleteCustomerInvoice,
  companyAccountVerifyPages,
  verifyPages,
  usageVerifyDetail,
  verify,
  cancelVerify,
  verifyDetailPages,
  verifySurcharges,
  reviewedReceivable,
  importReceivable,
  importPayable,
  postReviewedReceivable,
  postDeleteReceivableInvoice,
  postCancelReviewedReceivable,
  postCompleteReceivable,
  getSupplierPages,
  generateSupplierInvoices,
  getSupplierInvoiceStartDate,
  reviewSupplierInvoice,
  antiSupplierReviewInvoice,
  deleteSupplierInvoice,
  supplierInvoiceData,
  customerInvoiceData,
  generateInvoiceByPayable,
  generateInvoiceByReceivable,
  supplierAccountVerifyPages,
  verifyDetailPagesBySupplier,
  cancelVerifyBySupplier,
  verifyPagesBySupplier,
  verifyBySupplier,
  usageVerifyDetailBySupplier,
  companyBankAccount,
  batchBankAccountCompany,
  getInvoicePaymentVerifyDetails,
  getInvoicePaymentVerifyDetailsBySupplier,
  grossProfitOtherServiceDetail
  // getPayableDetailPages
}
